import { render, staticRenderFns } from "./_Fonts.vue?vue&type=template&id=3c31bf50&scoped=true&"
import script from "./_Fonts.vue?vue&type=script&lang=ts&"
export * from "./_Fonts.vue?vue&type=script&lang=ts&"
import style0 from "./_Fonts.vue?vue&type=style&index=0&id=3c31bf50&lang=scss&scoped=true&"
import style1 from "./_Fonts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c31bf50",
  null
  
)

export default component.exports